import { useTheme } from '@mui/material';
import styled from '@emotion/styled';

const IconWrapper = styled.button<{ pressColor: string; }>`
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;

  &:active svg rect {
    fill: #7c85b8; // 눌렀을 때 바뀌는 배경색
  }

  &:active svg path {
    fill: #f0f0f0; // 눌렀을 때 아이콘 색
  }
`;

const PauseIcon = ({ width = 40, height = 40 }: { width?: number; height?: number }) => {
  const theme = useTheme();
  return (
    <IconWrapper pressColor={theme.palette.secondary.main}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 54 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_i_593_3904)">
          <rect width="54" height="54" rx="16" fill={theme.palette.primary.main} />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 17.75H22C23.2426 17.75 24.25 18.7574 24.25 20V34C24.25 35.2426 23.2426 36.25 22 36.25H20C18.7574 36.25 17.75 35.2426 17.75 34V20C17.75 18.7574 18.7574 17.75 20 17.75ZM16 20C16 17.7909 17.7909 16 20 16H22C24.2091 16 26 17.7909 26 20V34C26 36.2091 24.2091 38 22 38H20C17.7909 38 16 36.2091 16 34V20ZM32 17.75H34C35.2426 17.75 36.25 18.7574 36.25 20V34C36.25 35.2427 35.2426 36.25 34 36.25H32C30.7573 36.25 29.75 35.2427 29.75 34V20C29.75 18.7574 30.7573 17.75 32 17.75ZM28 20C28 17.7909 29.7908 16 32 16H34C36.2091 16 38 17.7909 38 20V34C38 36.2092 36.2091 38 34 38H32C29.7908 38 28 36.2092 28 34V20Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_i_593_3904"
            x="0"
            y="0"
            width="55"
            height="55"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1" dy="1" />
            <feGaussianBlur stdDeviation="3.3" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.912047 0 0 0 0 0.912047 0 0 0 0 0.940267 0 0 0 1 0"
            />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_593_3904" />
          </filter>
        </defs>
      </svg>
    </IconWrapper>
  );
};

export default PauseIcon;
